import React from "react";
import AppointmentItem from "./appointment";
import arrow from '../../assets/images/arrow_left_icon.png'
import { useHistory } from "react-router-dom";

const NextAppointment = ({ next, project }) => {
  const history = useHistory();
  return (
    <div 
      className="next-appointment"
    >
      <div className="next-appointment-top">
        <div>Dein nächster Schulungstermin</div>
      </div>
      <AppointmentItem
       arrow={arrow}
       next={next}
       project={project}
       onClick={() => {
        history.push({
          pathname: `/appointment-details/${project.id}`,
          state: { appointmentId: project.id }
        });
      }}
      />
    </div>
  );
  };
  
  export default NextAppointment;
  